import React from "react";
import moment from "moment";
import { Alert } from "@mui/material";

// Shown on the edit screens once an auction is locked: 48 hours after its
// auction end, last lot end or post-bid end (whichever is later), nothing
// about it can be edited or deleted any more.
const EditLockedBanner = ({ editLocked, editLockAt }) => {
  if (!editLocked) {
    return null;
  }

  return (
    <Alert severity="warning" sx={{ my: 2 }}>
      This auction is locked since{" "}
      {moment(editLockAt).format("DD/MM/YYYY hh:mm A")} and cannot be edited
      or deleted.
    </Alert>
  );
};

export default EditLockedBanner;
